import { Bones } from '@simplywallst/ui-core';

import { Card, SkeletonLink, Returns, BoneWrapper, Details } from './styled';

interface Props {
  outline?: boolean;
}

const Skeleton = ({ outline }: Props) => {
  return (
    <Card outline={outline}>
      <SkeletonLink>
        <Details>
          <Bones />
          <BoneWrapper>
            <Bones />
          </BoneWrapper>
        </Details>
        <Returns>
          <li>
            <span>7D</span>
            <BoneWrapper>
              <Bones />
            </BoneWrapper>
          </li>
          <li>
            <span>1Y</span>
            <BoneWrapper>
              <Bones />
            </BoneWrapper>
          </li>
        </Returns>
      </SkeletonLink>
    </Card>
  );
};

export default Skeleton;
